import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const Mission = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-serif font-bold text-[#1a1a1a] mb-8 text-center">
            Notre mission
          </h1>

          <div className="prose prose-lg max-w-none">
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl mb-12 border border-gray-100">
              <p className="text-xl text-gray-700 leading-relaxed mb-0 font-semibold text-center">
                Documenter, analyser et expliquer les mouvements citoyens, les mobilisations sociales, les enjeux démocratiques et les évolutions sociétales
              </p>
            </div>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Pourquoi Giletau existe
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Dans un contexte de multiplication des mobilisations citoyennes et de transformation profonde de nos démocraties, il est essentiel de disposer d'espaces d'information rigoureux et indépendants. Giletau a été créé pour répondre à ce besoin : offrir une documentation et une analyse de qualité sur les mouvements sociaux et les enjeux démocratiques contemporains.
            </p>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Nos objectifs
            </h2>
            
            <div className="space-y-8 mb-12">
              <div className="bg-white p-6 rounded-xl border-l-4 border-[#1a1a1a]">
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 flex items-center gap-3">
                  <i className="ri-file-text-line text-2xl"></i>
                  Documenter les mouvements citoyens
                </h3>
                <p className="text-gray-700 leading-relaxed mb-0">
                  Recenser, archiver et contextualiser les mobilisations sociales, les manifestations et les actions collectives qui marquent notre époque. Donner la parole aux acteurs de terrain et préserver la mémoire de ces mouvements.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border-l-4 border-[#1a1a1a]">
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 flex items-center gap-3">
                  <i className="ri-search-line text-2xl"></i>
                  Analyser les dynamiques sociales
                </h3>
                <p className="text-gray-700 leading-relaxed mb-0">
                  Décrypter les causes, les revendications et les impacts des mouvements sociaux. Mettre en lumière les mécanismes de mobilisation collective et les transformations sociétales en cours.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border-l-4 border-[#1a1a1a]">
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 flex items-center gap-3">
                  <i className="ri-lightbulb-line text-2xl"></i>
                  Expliquer les enjeux démocratiques
                </h3>
                <p className="text-gray-700 leading-relaxed mb-0">
                  Rendre accessibles les questions institutionnelles, les débats de société et les évolutions de nos systèmes démocratiques. Éclairer les citoyens sur leurs droits et les outils de participation collective.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border-l-4 border-[#1a1a1a]">
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 flex items-center gap-3">
                  <i className="ri-community-line text-2xl"></i>
                  Favoriser le débat citoyen
                </h3>
                <p className="text-gray-700 leading-relaxed mb-0">
                  Créer un espace d'information pluraliste qui nourrit la réflexion collective et encourage l'engagement démocratique. Contribuer à un débat public éclairé et constructif.
                </p>
              </div>
            </div>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Nos valeurs fondamentales
            </h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-6">
              <li><strong>Indépendance :</strong> Aucune affiliation politique, économique ou idéologique</li>
              <li><strong>Rigueur :</strong> Vérification des sources, contextualisation et analyse approfondie</li>
              <li><strong>Pluralisme :</strong> Écoute de tous les points de vue et respect de la diversité des opinions</li>
              <li><strong>Accessibilité :</strong> Information claire et compréhensible par tous les citoyens</li>
              <li><strong>Transparence :</strong> Méthodologie explicite et sources toujours citées</li>
            </ul>

            <div className="bg-[#1a1a1a] text-white p-8 rounded-2xl mt-12">
              <h3 className="text-2xl font-bold mb-4">
                Notre promesse
              </h3>
              <p className="text-gray-200 leading-relaxed mb-0">
                Giletau s'engage à fournir une information de qualité, rigoureuse et indépendante sur les mouvements citoyens et les enjeux démocratiques. Nous mettons notre expertise au service de tous ceux qui souhaitent comprendre les transformations sociales et participer activement à la vie démocratique.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Mission;
